import { AfterViewInit, Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: '[draggable]'
})
export class DraggableDirective implements AfterViewInit {
  
  @Input() draggable;
  movent: boolean = false;
  xAnterior = 0;
  yAnterior = 0;

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.style.position = 'absolute';
    this.elementRef.nativeElement.parentNode.style.position = 'absolute';
    this.elementRef.nativeElement.parentNode.style.margin = '0';
  }

  @HostListener('mousedown', ['$event']) onMouseDown(event) {
    if(this.draggable != null){
      this.movent = true;
      this.xAnterior = event.clientX;
      this.yAnterior = event.clientY;
    }
  }

  @HostListener('document:mousemove', ['$event']) onMouseMove(event) {
    if (this.movent) {
      this.elementRef.nativeElement.style.left = (this.elementRef.nativeElement.offsetLeft + (event.clientX - this.xAnterior)) + 'px';
      this.elementRef.nativeElement.style.top = (this.elementRef.nativeElement.offsetTop + (event.clientY - this.yAnterior)) + 'px';
      this.xAnterior = event.clientX;
      this.yAnterior = event.clientY;
    }
  }

  @HostListener('document:mouseup') onMouseUp() {
    this.movent = false;
    this.xAnterior = 0;
    this.yAnterior = 0;
  }
}
